import MAComplianceAnalytics from './MAComplianceAnalytics'

export default MAComplianceAnalytics
